import { render, staticRenderFns } from "./add-users.vue?vue&type=template&id=1047231a&scoped=true&"
import script from "./add-users.vue?vue&type=script&lang=js&"
export * from "./add-users.vue?vue&type=script&lang=js&"
import style0 from "./add-users.vue?vue&type=style&index=0&id=1047231a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047231a",
  null
  
)

export default component.exports